const chatPanelTranslations = {
  es: {
    damyxiaIsYourOption: 'DamyxIA es tu Opción',
    copy: 'Copiar',
    copied: 'Copiado',
    export: 'Exportar',
    delete: 'Eliminar',
    downloadProject: 'Descargar Proyecto',
    downloading: 'Descargando...',
    copyConversation: 'Copiar conversación',
    downloadCode: 'Descargar código como proyecto',
    errorSendMessage: 'Error al enviar mensaje',
    errorSelectConversation: 'Selecciona o crea una conversación primero',
    fileAnalyzed: 'Archivo analizado correctamente',
    errorAnalyzeFile: 'Error al analizar archivo',
    imageSentForAnalysis: 'Imagen enviada para análisis',
    errorAnalyzeImage: 'Error al analizar la imagen',
    noMessagesForCopy: 'No hay mensajes para copiar',
    conversationCopied: 'Conversación copiada',
    conversationCopiedClipboard: 'Conversación copiada al portapapeles',
    errorCopy: 'Error al copiar',
    couldNotCopy: 'No se pudo copiar',
    noMessagesForExport: 'No hay mensajes para exportar',
    projectDownloaded: 'Proyecto descargado con',
    files: 'archivo(s)',
    conversationExported: 'Conversación exportada',
    errorExport: 'Error al exportar',
    noMessagesInConversation: 'No hay mensajes en la conversación',
    noCodeToDownload: 'No hay código para descargar',
    user: 'Usuario',
    exportPDF: 'Exportar PDF',
    pdfExported: 'PDF exportado correctamente',
    errorPDF: 'Error al exportar PDF',
    livePreview: 'Vista Previa',
    shareConversation: 'Compartir',
    rollback: 'Revertir',
    newConversation: 'Nueva conversación',
    errorCreatingConversation: 'Error al crear conversación',
    imageProcessed: 'Imagen procesada correctamente.',
    imageNotSaved: 'Imagen procesada pero hubo un problema al guardarla.',
    imageNotSavedSimple: 'Imagen procesada pero no se pudo guardar.',
    errorProcessingImage: 'Error al procesar la imagen',
    onlyImages: 'Solo se permiten imágenes',
    project: 'proyecto',
    conversation: 'conversación',
    workflow: 'Flujo de Trabajo',
    metrics: 'Métricas de Sesión',
    workflowShort: 'Flujo',
    metricsShort: 'Métricas',
    restoreFromSnapshot: 'Restaurar desde snapshot',
    dropImageHere: 'Suelta la imagen aquí',
    willAppearInChat: 'Se mostrará en la conversación',
    processing: 'Procesando...',
    messageDeleted: 'Mensaje eliminado',
    versionRestored: 'Versión restaurada correctamente',
    responseMode: 'Modo de respuesta:',
    activeModules: 'Módulos activos:',
  },
  en: {
    damyxiaIsYourOption: 'DamyxIA is Your Choice',
    copy: 'Copy',
    copied: 'Copied',
    export: 'Export',
    delete: 'Delete',
    downloadProject: 'Download Project',
    downloading: 'Downloading...',
    copyConversation: 'Copy conversation',
    downloadCode: 'Download code as project',
    errorSendMessage: 'Error sending message',
    errorSelectConversation: 'Select or create a conversation first',
    fileAnalyzed: 'File analyzed successfully',
    errorAnalyzeFile: 'Error analyzing file',
    imageSentForAnalysis: 'Image sent for analysis',
    errorAnalyzeImage: 'Error analyzing image',
    noMessagesForCopy: 'No messages to copy',
    conversationCopied: 'Conversation copied',
    conversationCopiedClipboard: 'Conversation copied to clipboard',
    errorCopy: 'Error copying',
    couldNotCopy: 'Could not copy',
    noMessagesForExport: 'No messages to export',
    projectDownloaded: 'Project downloaded with',
    files: 'file(s)',
    conversationExported: 'Conversation exported',
    errorExport: 'Error exporting',
    noMessagesInConversation: 'No messages in conversation',
    noCodeToDownload: 'No code to download',
    user: 'User',
    exportPDF: 'Export PDF',
    pdfExported: 'PDF exported successfully',
    errorPDF: 'Error exporting PDF',
    livePreview: 'Live Preview',
    shareConversation: 'Share',
    rollback: 'Rollback',
    newConversation: 'New conversation',
    errorCreatingConversation: 'Error creating conversation',
    imageProcessed: 'Image processed successfully.',
    imageNotSaved: 'Image processed but there was a problem saving it.',
    imageNotSavedSimple: 'Image processed but could not be saved.',
    errorProcessingImage: 'Error processing image',
    onlyImages: 'Only images are allowed',
    project: 'project',
    conversation: 'conversation',
    workflow: 'Workflow',
    metrics: 'Session Metrics',
    workflowShort: 'Workflow',
    metricsShort: 'Metrics',
    restoreFromSnapshot: 'Restore from snapshot',
    dropImageHere: 'Drop image here',
    willAppearInChat: 'It will appear in the conversation',
    processing: 'Processing...',
    messageDeleted: 'Message deleted',
    versionRestored: 'Version restored successfully',
    responseMode: 'Response mode:',
    activeModules: 'Active modules:',
  }
};

export default chatPanelTranslations;
